import { render, staticRenderFns } from "./ModalComprovanteDeposito.vue?vue&type=template&id=741e5c4f&scoped=true"
import script from "./ModalComprovanteDeposito.vue?vue&type=script&lang=js"
export * from "./ModalComprovanteDeposito.vue?vue&type=script&lang=js"
import style0 from "./ModalComprovanteDeposito.vue?vue&type=style&index=0&id=741e5c4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741e5c4f",
  null
  
)

export default component.exports